


export const TreemapDataProcess = () => {
  if(typeof window.__GTM_DOCS__ !== 'undefined'){
    let rawTags = window.__GTM_DOCS__.container.tag;
    let rawTriggers = window.__GTM_DOCS__.container.trigger;
    let rawVariables = window.__GTM_DOCS__.container.variable;
    let output = [{},{},{},{},{}];

    if(typeof rawTags !=='undefined'){
      output[0].name = 'Tags';
      output[0].children = [];
      output[1].name = 'Custom HTML Tags';
      output[1].children = [];
      rawTags.forEach((tag)=>{
        if(tag.type !== 'html'){
          output[0].children.push({"name":tag.name,"size":1})
        }else{
          output[1].children.push({"name":tag.name,"size":1})
        }
      })
    }

    if(typeof rawTriggers !=='undefined'){
      output[2].name = 'Triggers';
      output[2].children = [];
      rawTriggers.forEach((trigger)=>{
        output[2].children.push({"name":trigger.name,"size":1})
      })
    }

    if(typeof rawVariables !=='undefined'){
      output[3].name = 'Variables';
      output[3].children = [];
      output[4].name = 'Custom JS Variables';
      output[4].children = [];
      rawVariables.forEach((variable)=>{
        if(variable.type  !== 'jsm'){
          output[3].children.push({"name":variable.name,"size":1})
        }else{
          output[4].children.push({"name":variable.name,"size":1})
        }

      })
    }

// Removes any empty children arrays
    let finalOutput = [];
    output.forEach((child)=>{
      if(typeof child.children !== 'undefined'){
        if(child.children.length > 0){
          finalOutput.push(child);
        }
      }else{
          finalOutput = [{"name":"No Tags, Triggers or Variables Found","size":1}];
      }
    })

    return finalOutput;
  }
}
